import AppConstants from "../../../../constants/AppConstants";
import DesignChooserActions from "../../../../actions/DesignChooserActions";
import DocumentStore from "../../../../document/DocumentStore";
import { COMMANDS } from "../../../../document/commands";
import UIActions from "../../../../actions/UIActions";
import UserActions from "../../../../actions/UserActions";
import ModelFactory from "../../../../models/ModelFactory";
import SiteSettingsActions from "../../../../actions/SiteSettingsActions";

const {
  DESIGN_TYPE_PAGE,
  DESIGN_TYPE_WP_PAGE,
  DESIGN_TYPE_SITE_BLOCK,
  SITE_ITEM_BLOCK,
  SITE_ITEM_CANVAS_SET,
  SITE_ITEM_PAGE,
} = AppConstants;

export const openSiteSettingsModal = () => {
  SiteSettingsActions.openDialog();
};

export const openThemeModal = () => {
  UIActions.toggleActiveTheme();
};

export const showAssetLibrary = () => {
  const config = {
    title: "Manage Assets",
    mode: AppConstants.ASSET_LIBRARY_MODE_VIEW,
  };

  UIActions.toggleAssetChooser(config);
};

export const addPage = () => {
  DocumentStore.dispatch({ type: COMMANDS.ADD_PAGE });
  UserActions.trackEvent({ event: "page-add" });
};

export const choosePage = () => {
  DesignChooserActions.openDialog({
    title: "Choose A Page",
    designType: DESIGN_TYPE_PAGE,
  });
};

export const addPageFolder = () => {
  DocumentStore.dispatch({ type: COMMANDS.ADD_FOLDER });
};

export const addTemplateFolder = () => {
  DocumentStore.dispatch({ type: COMMANDS.ADD_FOLDER, payload: { isWp: true } });
};

export const addTemplate = () => {
  DocumentStore.dispatch({ type: COMMANDS.ADD_PAGE, payload: { toWP: true } });
  UserActions.trackEvent({ event: "page-add-wp" });
};

export const chooseTemplate = () => {
  DesignChooserActions.openDialog({
    title: "Choose A Blog Template",
    designType: DESIGN_TYPE_WP_PAGE,
  });
};

export const addSiteBlock = () => {
  DocumentStore.dispatch({
    type: COMMANDS.ADD_SITE_BLOCK,
    payload: { block: ModelFactory.getSiteBlock() },
  });
};

export const chooseSiteBlock = () => {
  DesignChooserActions.openDialog({
    title: "Choose A Canvas",
    designType: DESIGN_TYPE_SITE_BLOCK,
  });
};

export const createCanvasSet = () => {
  DocumentStore.dispatch({ type: COMMANDS.CREATE_CANVAS_SET });
  UserActions.trackEvent({ event: "canvas-set-add" });
};

export const isSelectedContainer = (type, itemId, blockContainer) =>
  blockContainer.get("type") === type && blockContainer.get("id") === itemId;

export const select = (item, blockContainer) => {
  const id = item.get("id");
  const type = item.get("type");
  const isSelected = isSelectedContainer(type, id, blockContainer);

  if (!isSelected) {
    const selector = {
      [SITE_ITEM_PAGE]: UIActions.selectPage,
      [SITE_ITEM_BLOCK]: UIActions.selectSiteBlock,
      [SITE_ITEM_CANVAS_SET]: UIActions.selectCanvasSet,
    }[type];

    selector({ [type]: item });
    UIActions.replaceActiveItemHistory({
      id,
      type,
      name: item.get("name"),
    });
  }
};
